/* --------------------------------------------------------------------------
	Expand
-------------------------------------------------------------------------- */

/* globals jQuery, Site */

(function ($, Site) {
	var $Dialog, $DialogDocument, $DialogTrigger, $Trigger, $Target, $DialogClose;

	function init() {
		if (!$('.js-expand').length) {
			return;
		}

		$Dialog = $('.js-expand-dialog');
		$DialogDocument = $('.js-expand-dialog-document');
		$DialogTrigger = $('.js-expand-dialog-trigger');
		$DialogClose = $('.js-expand-dialog-close');

		$(document).on('click touchstart', onDocumentClick);

		$DialogTrigger.attr('role', 'button').on('activate.swap', onTriggerActivate).on('deactivate.swap', onTriggerDeactivate);

		$DialogClose.on('click', onCloseClick).on('keydown', onCloseKeydown);

		$Dialog
			.attr({
				role: 'dialog',
				'aria-modal': 'true',
				'aria-hidden': 'true',
				tabindex: '0'
			})
			.on('keydown', onDialogKeydown)
			.on('keyup', onDialogKeyup)
			.find('a, button, input')
			.attr('tabindex', '-1');

		$DialogDocument.attr('role', 'document');

		$DialogTrigger.attr('role', 'button');
	}

	function onTriggerActivate() {
		$Trigger = $(this);
		$Target = $($(this).data('swap-target'));

		$('.js-expand-dialogs').addClass('active');
		openDialog();
	}

	function onTriggerDeactivate() {
		$('.js-expand-dialogs').removeClass('active');
		closeDialog();
	}

	function onCloseClick(e) {
		$Trigger.swap('deactivate');
	}

	function onCloseKeydown(e) {
		if (e.keyCode === 9) {
			// tab
			if (!e.shiftKey) {
				$Target.focus();
			}
		}
	}

	function onDialogKeydown(e) {
		if ($Dialog.is(':focus')) {
			if (e.keyCode === 9) {
				// tab
				if (e.shiftKey) {
					e.preventDefault();

					$Target.find('.js-expand-dialog-close').focus();
				}
			}
		}
	}

	function onDialogKeyup(e) {
		if (e.keyCode === 27) {
			// escape
			$Trigger.swap('deactivate');
		}
	}

	function onDocumentClick(e) {
		if ($('body').hasClass('dialog_open')) {
			if (!($(e.target).closest('.js-expand-dialog').length || $(escape.target).closest('.js-expand-dialog-trigger').length)) {
				$Trigger.swap('deactivate');
			}
		}
	}

	function openDialog() {
		$('html, body').addClass('dialog_open');

		$Target
			.attr('aria-hidden', 'false')
			.transition({ always: false, property: 'opacity' }, function () {
				$Target.focus();
			})
			.find('a, button, input')
			.removeAttr('tabindex', '-1');
	}

	function closeDialog() {
		$('html, body').removeClass('dialog_open');

		$Target.attr('aria-hidden', 'true').find('a, button, input').attr('tabindex', '-1');

		$Trigger.focus();
	}

	Site.OnInit.push(init);
})(jQuery, Site);
